import { type MetricVariable } from "@doitintl/cmp-models";
import { Box, Chip, Stack, Typography } from "@mui/material";

import { useAttributionsContext } from "../../../../../../../Context/AttributionsContext";
import { getMetricLabel } from "../../../../../utilities";

type MetricVariableProps = {
  metric: MetricVariable;
  letter: string;
};

const MetricVariable = ({ metric, letter }: MetricVariableProps) => {
  const { attributions } = useAttributionsContext();
  const atribution = attributions.find((allocation) => allocation.ref.id === metric.attribution.id);
  const chipLabel = atribution?.data.name || "Unknown";
  return (
    <Stack direction="row" sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Chip label={letter} />
      <Typography variant="body1" sx={{ maxWidth: 100, fontWeight: 500 }}>
        {getMetricLabel(metric.metric, "", "")}
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: 500 }}>
        of
      </Typography>
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Chip color="primary" label={chipLabel} size="small" variant="outlined" />
      </Box>
    </Stack>
  );
};

export default MetricVariable;
